import { render, staticRenderFns } from "./CourseVolunteers.vue?vue&type=template&id=506bdc2e&"
import script from "./CourseVolunteers.vue?vue&type=script&lang=js&"
export * from "./CourseVolunteers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports